import { API_CONFIG } from "../config/api.config";

export interface TriggerAutoScheduleRequest {
  targetDate?: string; // YYYY-MM-DD 格式
}

export interface TriggerAutoScheduleResponse {
  success: boolean;
  message: string;
}

/**
 * 调度器服务
 * 负责与后端调度器API的交互
 */
export class SchedulerService {
  private static readonly BASE_URL = API_CONFIG.BASE_URL;

  /**
   * 手动触发自动排任务
   * @param request 触发请求参数
   * @returns 触发结果
   */
  static async triggerAutoSchedule(
    request: TriggerAutoScheduleRequest = {}
  ): Promise<TriggerAutoScheduleResponse> {
    try {
      const response = await fetch(
        `${this.BASE_URL}${API_CONFIG.ENDPOINTS.SCHEDULER_TRIGGER}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(request),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("触发自动排任务失败:", error);
      throw new Error(
        error instanceof Error
          ? error.message
          : "触发自动排任务失败，请稍后重试"
      );
    }
  }

  /**
   * 格式化日期为 YYYY-MM-DD 格式（本地时区）
   * @param date 日期对象
   * @returns 格式化后的日期字符串
   */
  static formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  /**
   * 获取今天的日期
   * @returns 今天的日期对象
   */
  static getTodayDate(): Date {
    return new Date();
  }
}

export default SchedulerService;
